export const resourcesParams = {
    resources: {
        params: {
            fields: {
                t: "Температура",
                p: "Давление",
                value_date: "Дата",
                powerstate: "Уровень заряда батареи",
                rssi: "Уровень сигнала связи",
            },
        },
    }
}